export const ConfRegActionTypes = {
  API_RESPONSE_SUCCESS: '@@confRegistro/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@confRegistro/API_RESPONSE_ERROR',

  GET_CONF_REG: '@@confRegistro/GET_CONF_REG',
  LIST_CONF_REG: '@@confRegistro/LIST_CONF_REG',
  ADD_CONF_REG: '@@confRegistro/ADD_CONF_REG',
  UPDATE_CONF_REG: '@@confRegistro/UPDATE_CONF_REG',
  DELETE_CONF_REG: '@@confRegistro/DELETE_CONF_REG',
  SET_FILTER: '@@confRegistro/SET_FILTER',

  RESET: '@@confRegistro/RESET'
}
